function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#00408F;}\n\t.st1{fill:#22509F;}\n\t.st2{fill:#062B71;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  id: "Path_237",
  d: "M183.7,0L183.7,0z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "background st1",
  d: "M655.1,100h113.5c23.6-15.1,43.8-37.7,65.4-62.4V0H563.7c14,14.4,26.8,29.8,39.1,44.6 C620.9,66.1,637.6,86.1,655.1,100z"
}), React.createElement("path", {
  className: "background st1",
  d: "M492.1,0H359.9c-24.4,15.8-45.1,39.4-67.5,65.1c-10.1,11.6-20.5,23.5-31.7,34.9h328.6 c-7.4-8.4-14.7-17.1-21.9-25.8C543.4,45.5,520.2,17.8,492.1,0z"
}), React.createElement("path", {
  className: "background st1",
  d: "M0,100h10.1C6.7,96.2,3.3,92.3,0,88.4V100z"
}), React.createElement("path", {
  className: "background st1",
  d: "M75.9,100h113.5c24.6-15.8,45.5-39.6,68.1-65.4c10-11.4,20.3-23.3,31.4-34.6H0v16.7C8.2,26,16,35.4,23.7,44.6 C41.7,66.1,58.4,86.1,75.9,100z"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "wave st2",
  d: "M768.6,100H834V37.6C812.4,62.3,792.2,84.9,768.6,100z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "wave st2",
  d: "M602.9,44.6C590.5,29.8,577.7,14.4,563.7,0h-71.7c28.2,17.8,51.3,45.5,75.2,74.2c7.2,8.6,14.5,17.3,21.9,25.8 h65.9C637.6,86.1,620.9,66.1,602.9,44.6z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "wave st2",
  d: "M23.7,44.6C16,35.4,8.2,26,0,16.7v71.7c3.3,3.9,6.7,7.8,10.1,11.6h65.9C58.4,86.1,41.7,66.1,23.7,44.6z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "wave st2",
  d: "M359.9,0h-71c-11.1,11.3-21.4,23.1-31.4,34.6c-22.6,25.8-43.4,49.7-68.1,65.4h71.2 c11.2-11.4,21.6-23.4,31.7-34.9C314.8,39.4,335.5,15.8,359.9,0z"
});

var SvgDesktopWave = function SvgDesktopWave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 834 100",
    style: {
      enableBackground: "new 0 0 834 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDesktopWave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DesktopWave.2640645f.svg";
export { ForwardRef as ReactComponent };